export default __webpack_public_path__ + "static/media/sushi2.8afd50cc.svg";